import { render } from "./CybersecurityPage.vue?vue&type=template&id=10fc019a"
import script from "./CybersecurityPage.vue?vue&type=script&lang=js"
export * from "./CybersecurityPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__